import { z } from 'zod';

import {
	ContractStatus1V1x4,
	InsuranceTypeV1,
} from '../../../../../api/generated/cz.pbktechnology.coop.bank.insurance.backoffice';
import { createEnumArraySchema } from '../../../../../helpers/zod/createEnumArraySchema';

export const FILTER_BANK_INSURANCES_STATES = {
	[ContractStatus1V1x4.ACTIVE]: ContractStatus1V1x4.ACTIVE,
	[ContractStatus1V1x4.TERMINATED]: ContractStatus1V1x4.TERMINATED,
} as const;

export type FilterBankInsurancesStatesKeys =
	(typeof FILTER_BANK_INSURANCES_STATES)[keyof typeof FILTER_BANK_INSURANCES_STATES];

export const clientBankInsurancesFilterFormSchema = z.object({
	status: createEnumArraySchema(FILTER_BANK_INSURANCES_STATES),
	type: createEnumArraySchema(InsuranceTypeV1),
});

export type ClientBankInsurancesFilterForm = z.infer<
	typeof clientBankInsurancesFilterFormSchema
>;
